import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import { getPartialCurrentUser } from '../api';

type PartialCurrentUserModel = Awaited<ReturnType<typeof getPartialCurrentUser>>;

export const usePartialCurrentUser = (options?: {
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
}): UseQueryResult<PartialCurrentUserModel, Error> => {
  const { enabled = true, refetchOnWindowFocus = true } = options ?? {};
  return useQuery('PARTIAL_CURRENT_USER', getPartialCurrentUser, { enabled, refetchOnWindowFocus });
};
